import axiosInstance from "../../utils/axios";

const fetchPermissions = async (values) => {
  try {
    const response = await axiosInstance.get("/permission", values);
    return { isStatus: true, data: response.data };
  } catch (err) {
    return { isStatus: false, data: null, message: err.message };
  }
};

const PermissionAPI = {
  fetchPermissions,
};

export default PermissionAPI;
